import { useEffect } from 'react'
import { CURRENT_CONFIG } from '../config/environment'

export interface RedirectToPublicSiteProps {
  /** Path on the public site (e.g. "/about", "/knowledge-hub"). No trailing slash. */
  path: string
}

/**
 * Performs a full-page redirect to the public site of this environment (intraction.com in production).
 * Used when the app no longer hosts public pages; they live on the separate public site.
 */
export function RedirectToPublicSite({ path }: RedirectToPublicSiteProps) {
  useEffect(() => {
    const url = path.startsWith('/')
      ? `${CURRENT_CONFIG.publicSiteUrl}${path}`
      : `${CURRENT_CONFIG.publicSiteUrl}/${path}`
    // Replaced, not added: Back from the public site returns to the page they came from, not to this redirect.
    window.location.replace(url)
  }, [path])
  return null
}

export default RedirectToPublicSite
